import { render, staticRenderFns } from "./ResourceCreate.vue?vue&type=template&id=a760d662&scoped=true"
import script from "./ResourceCreate.vue?vue&type=script&lang=js"
export * from "./ResourceCreate.vue?vue&type=script&lang=js"
import style0 from "./ResourceCreate.vue?vue&type=style&index=0&id=a760d662&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a760d662",
  null
  
)

export default component.exports